import React from 'react';

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  name?: string;
  modes: string[];
  value: string;
  disabled: boolean;
  onChange: (changed: string) => void;
}

/**
 * Thin wrapper around SelectStringBox for picking an enhancement mode
 * (Leave / Replace / Replace if Greater / Add). The set of valid modes
 * varies by field, so `modes` is passed in rather than hardcoded.
 */
export default function EnhancementModeBox({
  name = "Mode",
  modes,
  value,
  disabled,
  onChange
}: Props) {
  return (
    <SelectStringBox
      name={name}
      options={modes}
      value={value}
      disabled={disabled}
      onChange={(changed: string) => {
        onChange(changed);
      }}
    />
  );
}
